// extracted by mini-css-extract-plugin
export default {"feature-flag-desc-wrapper":"feature-flag-desc-wrapper__hSTp"};